import { schema } from 'normalizr';

export const cpsrChapterSchema = new schema.Entity(
  'cpsrChapters',
  {},
  { idAttribute: 'CpsrChapterId' },
);
export const cpsrChapterListSchema = [cpsrChapterSchema];
